module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('deleted-page-component', [_c('div', {
    staticClass: "content-container"
  }, [_c('p', {
    staticClass: "mb-30"
  }, [_vm._v(_vm._s(_vm.userName ? _vm.userName : 'User') + " is not avaliable anymore. Hit the button below to change your expert or continue journey with " + _vm._s(_vm.dealerName ? _vm.dealerName : 'dealer'))]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('f7-link', {
    staticClass: "button-primary",
    attrs: {
      "href": _vm.newExpertUrl,
      "no-link-class": "",
      "external": ""
    }
  }, [_vm._v("Select your new Expert")]), _vm._v(" "), _c('f7-link', {
    staticClass: "button-simple",
    attrs: {
      "href": _vm.websiteUrl,
      "no-link-class": "",
      "external": ""
    }
  }, [_vm._v("Go to " + _vm._s(_vm.dealerName ? _vm.dealerName : "dealer's") + " website")])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-18540dd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18540dd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/deleted/deleted-salesperson.vue
// module id = 740
// module chunks = 0